import { useCallback } from 'react';

import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../../api';
import { backerKeys } from '../../../query-key-factory';
import { ConsumerBackerActivityResponse } from './activity.types';

const useGetBackerConsumerBackerActivity = () => {
  const BackerApi = useBackerApi();

  const getBackerActivity = useCallback(async () => {
    const { data } = await BackerApi.get<ConsumerBackerActivityResponse>(
      '/consumer/backer/activity'
    );
    return data;
  }, [BackerApi]);

  return getBackerActivity;
};

const useShowConsumerBackerActivity = <T = ConsumerBackerActivityResponse>({
  select,
}: { select?: (data: ConsumerBackerActivityResponse) => T } = {}) => {
  const getConsumerBackerActivity = useGetBackerConsumerBackerActivity();

  return useQuery({
    queryKey: backerKeys.consumer.backer.activity.detail,
    queryFn: getConsumerBackerActivity,
    select,
  });
};

const usePrefetchConsumerBackerActivity = () => {
  const getConsumerBackerActivity = useGetBackerConsumerBackerActivity();
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.prefetchQuery({
      queryKey: backerKeys.consumer.backer.activity.detail,
      queryFn: getConsumerBackerActivity,
    });
  }, [queryClient, getConsumerBackerActivity]);
};

export { usePrefetchConsumerBackerActivity, useShowConsumerBackerActivity };
